import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Brand, BrandNavigation } from '../../../entities/Brand/Brand';
import { AsyncReduxState, initialAsyncReduxState } from '../../defaults';

export type BrandsState = AsyncReduxState<{
    ssrBrandQuery?: string;
    brands: Brand[];
    navigation?: BrandNavigation;
}>;

const initialState: BrandsState = {
    ...initialAsyncReduxState,
    brands: [],
};

const brandsSlice = createSlice({
    name: 'brandsSlice',
    initialState,
    reducers: {
        setIsLoading(state, action: PayloadAction<boolean>): BrandsState {
            return {
                ...state,
                isLoading: action.payload,
            };
        },
        setHasFetched(state, action: PayloadAction<boolean>): BrandsState {
            return {
                ...state,
                hasFetched: action.payload,
            };
        },
        setIsSuccessful(state, action: PayloadAction<boolean>): BrandsState {
            return {
                ...state,
                isSuccessful: action.payload,
            };
        },
        setError(state, action: PayloadAction<string>): BrandsState {
            return {
                ...state,
                error: action.payload,
            };
        },
        setBrands(state, action: PayloadAction<Brand[]>): BrandsState {
            return {
                ...state,
                brands: action.payload,
            };
        },
        setNavigation(state, action: PayloadAction<BrandNavigation | undefined>): BrandsState {
            return {
                ...state,
                navigation: action.payload,
            };
        },
    },
});

export const {
    setIsLoading,
    setHasFetched,
    setIsSuccessful,
    setError,
    setBrands,
    setNavigation,
} = brandsSlice.actions;

export default brandsSlice;
